import cn from "classnames";
import PropTypes from "prop-types";
import styles from "components/shared/stays/SurfSeasonDot.module.scss";

export default function SurfSeasonDot({ season = "l" }) {
  return <div className={cn(styles.component, styles[season])} />;
}

SurfSeasonDot.propTypes = {
  season: PropTypes.string.isRequired,
};
